
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Link from '@/ui-kit/components/link';
import ExternalLink from '@/ui-kit/components/external-link';
import { FooterLinkProp } from './enums';

export default {
  name: 'AuthFooterLinks',
  components: {
    Link,
    ExternalLink,
  },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      StyleColorSchemeType,
    };
  },
  methods: {
    linkType(link) {
      return link[FooterLinkProp.IsExternal]
        ? ExternalLink
        : Link;
    },
  },
};
